import React from 'react';
import clsx from 'clsx';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../common/types';
import { ErrorView } from '../../common/views/ErrorView/ErrorView';
import { ErrorViewProps } from '../../common/views/ErrorView/props';
import { artistHomeMessages as messages } from './artistHomeMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the whole Home; each part uses its own slice of it */
import styles from './ArtistHome.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface HomeRowErrorProps {
  error: ErrorViewProps['error'];
  retry: () => void;
}

/** A KPI row whose read failed: the standard ErrorView, and the rest of Home still works (design b3). */
const HomeRowErrorComponent: React.FC<HomeRowErrorProps> = ({ error, retry }) => {
  const intl = useIntl();
  return (
    <div className={styles.kpis}>
      <div className={clsx(styles.kpi, styles.span4)}>
        <ErrorView error={error} retry={retry} />
        <p className={styles.blockError}>{intl.formatMessage(messages.blockError)}</p>
      </div>
    </div>
  );
};

export const HomeRowError = TypedMemo(HomeRowErrorComponent);
